export default __webpack_public_path__ + "static/media/music_note_black_24dp.a26ca633.svg";